// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__lk","cls2":"SimplePaperPodcast-cls2_GyH SimplePaperPodcast-cls1__lk"};